import React from 'react'
import { Divider, Grid } from '@mui/material'
import { getTransLang } from '../components/MultiLanguage/dynamic-content-translate'

const KeyValueDivider = (props) => {
  return (
    <Grid container>
    {(Object.keys(props?.data).map((key, i) => (
      <Grid item container key={i}>
        <Grid item xs={12} lg={6} md={6}>
            <span className="blue fade-leave">{getTransLang(props?.language)[key]}</span>
        </Grid>
        <Grid item xs={12} lg={6} md={6} sx={{ pb: 1 }}>
            <span>{props?.data[key]}</span>
        </Grid>
        {(Object.keys(props?.data)?.length - 1) !== i &&
            (<Grid item xs={12} lg={12} md={12} sx={{ mt: 1.3, mb: 1.3 }}>
            <Divider />
            </Grid>)
        }
      </Grid>
    )))}
    </Grid>
  )
}

export default KeyValueDivider
